import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: 'Was ist ein Oopbuy Spreadsheet?',
    answer: 'Ein Oopbuy Spreadsheet ist eine umfassende und strukturierte Tabelle, die gepr&uuml;fte Produkte, vertrauensw&uuml;rdige Verk&auml;ufer, aktuelle Preise und wichtige Einkaufsinformationen enth&auml;lt. Es wurde entwickelt, um Online-Shoppern den Einkaufsprozess zu erleichtern und ihnen zu helfen, die besten Angebote zu finden.',
  },
  {
    question: 'Wie funktioniert das Oopbuy Spreadsheet?',
    answer: 'Das Oopbuy Spreadsheet funktioniert als zentrale Datenbank, in der alle relevanten Informationen zu Produkten und Verk&auml;ufern gesammelt und regelm&auml;&szlig;ig aktualisiert werden. Nutzer k&ouml;nnen nach Kategorien filtern, Verk&auml;ufer vergleichen und die besten Deals identifizieren.',
  },
  {
    question: 'Ist das Oopbuy Spreadsheet kostenlos?',
    answer: 'Ja, das Oopbuy Spreadsheet ist grunds&auml;tzlich kostenlos nutzbar. Es gibt verschiedene Versionen und Zug&auml;nge, die wir auf unserer Hauptseite detailliert vorstellen. Besuche einfach die Kategorieseiten, um mehr zu erfahren.',
  },
  {
    question: 'Welche Produkte finde ich im Oopbuy Spreadsheet?',
    answer: 'Im Oopbuy Spreadsheet findest du eine gro&szlig;e Auswahl an Produkten: Sneaker von Nike, Jordan und Adidas, Streetwear, Hoodies, Jacken, T-Shirts, Hosen, Accessoires, Taschen, G&uuml;rtel, Parfums und vieles mehr.',
  },
  {
    question: 'Wie aktuell sind die Daten im Spreadsheet?',
    answer: 'Die Daten im Oopbuy Spreadsheet werden regelm&auml;&szlig;ig aktualisiert – in der Regel w&ouml;chentlich oder sogar t&auml;glich. So stellen wir sicher, dass du immer Zugriff auf die neuesten Verk&auml;uferinformationen und Produktangebote hast.',
  },
  {
    question: 'Wie sicher ist das Einkaufen mit dem Oopbuy Spreadsheet?',
    answer: 'Sehr sicher. Alle im Spreadsheet gelisteten Verk&auml;ufer werden vor der Aufnahme gepr&uuml;ft. Wir achten auf Verk&auml;uferbewertungen, QC-Bilder und Transparenz. Zus&auml;tzlich geben wir Sicherheitstipps f&uuml;r den gesamten Einkaufsprozess.',
  },
  {
    question: 'Kann ich das Oopbuy Spreadsheet auf Deutsch nutzen?',
    answer: 'Ja, unser Guide und das gesamte Begleitmaterial sind komplett auf Deutsch verf&uuml;gbar. Wir erkl&auml;ren jeden Schritt verst&auml;ndlich und bieten eine vollst&auml;ndige deutsche Anleitung.',
  },
  {
    question: 'Welche Zahlungsmethoden werden unterst&uuml;tzt?',
    answer: '&Uuml;ber die Plattformen, die mit dem Oopbuy Spreadsheet verbunden sind, stehen verschiedene Zahlungsmethoden zur Verf&uuml;gung – darunter PayPal, Kreditkarte und weitere sichere Optionen.',
  },
  {
    question: 'Gibt es eine Oopbuy Spreadsheet Alternative?',
    answer: 'Es gibt einige Alternativen, aber das Oopbuy Spreadsheet zeichnet sich durch seine umfassende Datenbank, regelm&auml;&szlig;ige Aktualisierungen und die benutzerfreundliche Struktur aus. In unserem Guide vergleichen wir verschiedene Optionen.',
  },
  {
    question: 'F&uuml;r wen ist das Oopbuy Spreadsheet geeignet?',
    answer: 'Das Oopbuy Spreadsheet ist sowohl f&uuml;r Anf&auml;nger als auch f&uuml;r erfahrene Shopper geeignet. Anf&auml;nger profitieren von den einfachen Erkl&auml;rungen, w&auml;hrend Profis die detaillierten Verk&auml;uferinformationen und QC-Daten sch&auml;tzen.',
  },
  {
    question: 'Wie finde ich die besten Sneaker im Oopbuy Spreadsheet?',
    answer: 'Nutze die Kategoriefilter f&uuml;r Sneaker und w&auml;hle dann nach Marke wie Nike, Jordan oder Adidas. Das Spreadsheet zeigt dir die besten Angebote mit Verk&auml;uferbewertungen und verf&uuml;gbaren Gr&ouml;&szlig;en.',
  },
  {
    question: 'Was bedeutet QC im Zusammenhang mit dem Spreadsheet?',
    answer: 'QC steht f&uuml;r Quality Control (Qualit&auml;tskontrolle). Im Oopbuy Spreadsheet findest du Informationen dar&uuml;ber, welche Verk&auml;ufer QC-Bilder anbieten und wie du die Qualit&auml;t der Produkte vor dem Kauf &uuml;berpr&uuml;fen kannst.',
  },
  {
    question: 'Wie oft wird das Oopbuy Spreadsheet aktualisiert?',
    answer: 'Das Oopbuy Spreadsheet wird kontinuierlich gepflegt. Neue Verk&auml;ufer und Produkte werden hinzugef&uuml;gt, sobald sie gepr&uuml;ft wurden. Inaktive oder nicht vertrauensw&uuml;rdige Eintr&auml;ge werden regelm&auml;&szlig;ig entfernt.',
  },
  {
    question: 'Kann ich eigene Verk&auml;ufer zum Spreadsheet hinzuf&uuml;gen?',
    answer: 'Das Oopbuy Spreadsheet wird von einem erfahrenen Team kuratiert. Wenn du einen guten Verk&auml;ufer kennst, kannst du ihn &uuml;ber unsere Hauptseite vorschlagen. Wir pr&uuml;fen alle Vorschl&auml;ge sorgf&auml;ltig.',
  },
  {
    question: 'Gibt es einen Oopbuy Spreadsheet Discord oder Community?',
    answer: 'Ja, rund um das Oopbuy Spreadsheet hat sich eine aktive Community gebildet. Auf unserer Hauptseite findest du Links zu Discord-Servern und anderen Community-Plattformen, wo sich Nutzer austauschen.',
  },
  {
    question: 'Welche Vorteile bietet das Oopbuy Spreadsheet gegen&uuml;ber Yupoo?',
    answer: 'Das Oopbuy Spreadsheet bietet eine strukturiertere &Uuml;bersicht als Yupoo-Alben. Du findest geb&uuml;ndelte Informationen, Verk&auml;uferbewertungen und aktuelle Preise an einem Ort – ohne durch unz&auml;hlige Alben navigieren zu m&uuml;ssen.',
  },
  {
    question: 'Wie starte ich als Anf&auml;nger mit dem Oopbuy Spreadsheet?',
    answer: 'Beginne mit unserem Einsteiger-Guide auf der Hauptseite. W&auml;hle eine Kategorie, die dich interessiert, und folge den Schritt-f&uuml;r-Schritt-Anleitungen. Das Spreadsheet ist intuitiv aufgebaut und leicht zu navigieren.',
  },
  {
    question: 'Unterst&uuml;tzt das Oopbuy Spreadsheet den Versand nach Deutschland?',
    answer: 'Ja, viele der im Spreadsheet gelisteten Verk&auml;ufer bieten Versand nach Deutschland und in die gesamte EU an. In unserem Shipping-Guide erkl&auml;ren wir, worauf du beim internationalen Versand achten musst.',
  },
  {
    question: 'Wie erkenne ich vertrauensw&uuml;rdige Verk&auml;ufer im Spreadsheet?',
    answer: 'Vertrauensw&uuml;rdige Verk&auml;ufer sind im Spreadsheet besonders gekennzeichnet. Wir bewerten sie nach Kriterien wie Bewertungen, QC-Verf&uuml;gbarkeit, Kommunikation und Lieferzuverl&auml;ssigkeit.',
  },
  {
    question: 'Wo finde ich den aktuellen Oopbuy Spreadsheet Link?',
    answer: 'Den aktuellen Oopbuy Spreadsheet Link findest du direkt auf unserer Hauptseite. Besuche einfach eine der Kategorieseiten oder klicke auf einen der Buttons auf dieser Website.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
            H&auml;ufig gestellte Fragen
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            Alles, was du &uuml;ber das Oopbuy Spreadsheet wissen musst
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="font-semibold text-sm md:text-base text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="p-4 md:p-5 pt-0 text-foreground-600 text-sm leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}